module.exports = __webpack_public_path__ + "img/SDP.3a0b6728.png";